import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    isReportConcernLoading: false,
    isContactSupportLoading: false,
    error: null,
}

const supportSlice = createSlice({
    name: "support",
    initialState,
    reducers: {
        reportConcernLoading: (state) => {
            state.isReportConcernLoading = true
        },
        reportConcernFailure: (state, action) => {
            state.isReportConcernLoading = false
            state.error = action.payload
        },
        reportConcernSuccess: (state) => {
            state.isReportConcernLoading = false
            state.error = null
        },
        contactSupportLoading: (state) => {
            state.isContactSupportLoading = true
        },
        contactSupportFailure: (state, action) => {
            state.isContactSupportLoading = false
            state.error = action.payload
        },
        contactSupportSuccess: (state) => {
            state.isContactSupportLoading = false
            state.error = null
        },
    },
})

export const {
    reportConcernLoading,
    reportConcernFailure,
    reportConcernSuccess,
    contactSupportLoading,
    contactSupportFailure,
    contactSupportSuccess,
} = supportSlice.actions
export default supportSlice.reducer
